import { render, staticRenderFns } from "./OrderRetailEdit.vue?vue&type=template&id=eebcce08&scoped=true&"
import script from "./OrderRetailEdit.vue?vue&type=script&lang=js&"
export * from "./OrderRetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebcce08",
  null
  
)

export default component.exports